"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var storybook_1 = require("@eyecons/storybook");
function TypeSelectorScreen(_a) {
    var setHlsScreen = _a.setHlsScreen, createType = _a.createType;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Texts.Heading, { className: 'mb-4', type: 'h3' }, "Maak een keuze uit onderstaande opties"),
        react_1.default.createElement("div", { className: 'm-4 p-4 text-left bg-white hover:shadow-xl border-gray-300 hover:border-gray-200 border rounded-md cursor-pointer', onClick: function () { return createType('rtmp'); } },
            react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', className: 'mb-4' }, "RTMP-kanaal"),
            react_1.default.createElement(storybook_1.Texts.Small, null, "Maak eenvoudig gebruik van RTMP of RTMPS, let op: hiervoor worden \u20AC4,90 incl btw aan kosten per uur voor cloud transcoding in rekening gebracht. Een actueel overzicht van kosten vind je terug in het billing dashboard.")),
        react_1.default.createElement("div", { className: 'm-4 p-4 text-left bg-white hover:shadow-xl border-gray-300 hover:border-gray-200 border rounded-md cursor-pointer', onClick: function () { return setHlsScreen(true); } },
            react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', className: 'mb-4' }, "HLS-kanaal (gratis)"),
            react_1.default.createElement(storybook_1.Texts.Small, null, "HLS is onder meer geschikt voor automatische camera's, hiervoor worden geen kosten in rekening gebracht. Vraag de pull zone informatie op bij jouw camera leverancier.")));
}
function HlsScreen(_a) {
    var createType = _a.createType, setHlsScreen = _a.setHlsScreen, livestream = _a.livestream, setLivestream = _a.setLivestream;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Livestreams.FormHls, { livestream: livestream.data, setLivestream: setLivestream }),
        react_1.default.createElement(storybook_1.Forms.Buttons, { loading: livestream.submitting, errors: livestream.errors },
            react_1.default.createElement(storybook_1.Buttons.Button, { type: 'secondary', onClick: function () { return setHlsScreen(false); } }, "Terug"),
            react_1.default.createElement(storybook_1.Buttons.Button, { type: 'primary', disabled: livestream.submitting, onClick: function () { return createType('hls'); } }, "Opslaan")));
}
function Create(_a) {
    var livestream = _a.livestream, setLivestream = _a.setLivestream, saveLivestream = _a.saveLivestream;
    var _b = react_1.useState(false), isLoading = _b[0], setLoading = _b[1];
    var _c = react_1.useState(false), hlsScreenVisible = _c[0], setHlsScreen = _c[1];
    function createType(type) {
        setLoading(true);
        saveLivestream({
            type: type,
        }).then(function (response) {
            if (!response.errors.length) {
                window.location.href = process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/livestreams/" + response.data.id + "/edit";
                return;
            }
            setLoading(false);
        });
    }
    if (isLoading) {
        return react_1.default.createElement("div", { className: 'storybook-layouts-fullscreen' },
            react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' }),
            react_1.default.createElement("div", { className: 'pt-4' }, "Livestream wordt aangemaakt.."));
    }
    return react_1.default.createElement(storybook_1.Layouts.Fullscreen, { returnUrl: '/livestreams' },
        react_1.default.createElement(storybook_1.Texts.Heading, { className: 'text-center font-bold' }, hlsScreenVisible ? 'Nieuwe HLS stream' : 'Nieuwe livestream'),
        react_1.default.createElement("div", { className: 'lg:w-3/5 mx-auto rtmp-hls-wrapper' }, hlsScreenVisible
            ? react_1.default.createElement(HlsScreen, { createType: createType, setHlsScreen: setHlsScreen, livestream: livestream, setLivestream: setLivestream })
            : react_1.default.createElement(TypeSelectorScreen, { createType: createType, setHlsScreen: setHlsScreen })));
}
exports.default = Create;
